 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Overriding Account No
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryOvrdAcctNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryOvrdAcctNoFilterForm"
                            v-model="filtersOvrdAcctNo.ovrdAcctNo"
                            :label="filtersOvrdAcctNoLabel.ovrdAcctNo"
                            :error-messages="errors.collect('filterOvrdAcctNo')"
                            data-vv-name="filterOvrdAcctNo"
                            :data-vv-as="filtersOvrdAcctNoLabel.ovrdAcctNo"
                            v-validate="'entry|max:8'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearOvrdAcctNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doOvrdAcctNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="ovrdAcctNoHeaders"
          :items="ovrdAcctNoItems"
          v-bind:options.sync="paginationOvrdAcctNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsOvrdAcctNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.inter }}</td>
              <td>{{ row.item.name }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignOvrdAcctNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationOvrdAcctNo: {
        page: 1
      }
    }
  },
  mounted() {
    this.doClearOvrdAcctNoFilters()
  },
  methods: {
    closeDialog() {
      this.filtersOvrdAcctNo.ovrdAcctNo = ''
      this.$emit('close')
    },
    doClearOvrdAcctNoFilters() {
      this.filtersOvrdAcctNo.ovrdAcctNo = ''
      this.fetchOvrdAcctNoData()
    },
    doOvrdAcctNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryOvrdAcctNoFilterForm').then((result) => {
        if (result) {
          this.paginationOvrdAcctNo.page = 1
          this.fetchOvrdAcctNoData()
        }
      })
    },
    assignOvrdAcctNo(data) {
      // Use $emit to call parent Overriding Accounts page method assignOvrdAcctNo and pass the value
      this.$emit('assign-ovrd-acct-no', data.inter)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, accountsFilters, commonAjaxMixin]
}
</script>
